import { useEffect } from 'react'
import { useAppDispatch } from 'shared/store/store'

const useResetStateOnDismount = (type: string) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    return () => {
      dispatch({ type })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export default useResetStateOnDismount
